import { render, staticRenderFns } from "./withdrawalcord.vue?vue&type=template&id=f74fa6b0"
import script from "./withdrawalcord.vue?vue&type=script&lang=js"
export * from "./withdrawalcord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports